import { useMemo } from "react"
import PropTypes from "prop-types"
import AssetViewPanelPeriodControl from "connected-components/asset-view/components/panel-period-control"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { useAnalytics } from "connected-components/analytics"
import { useAssetViewHeaderHandlers } from "connected-components/asset-view/hooks/use-asset-view-header-handlers"
import { getFactorCategoryDropdownOptions } from "connected-components/asset-view/helpers/header-dropdown-options"
import { useSourceTemplateMetricIds } from "connected-components/asset-view/hooks/use-source-displayed-metrics"
import { COMPOSITION_VISIBILITY_SHAPE } from "connected-components/asset-view/prop-types"
import { useAssetViewTemplateChart } from "../../hooks/use-asset-view-template-chart"
import { ASSET_VIEW_PERFORMANCE_CHART } from "../template-chart-config"

export default function PerformanceHeader({ modelMetadata, flattenedMetrics, onMetricsChange, compositionVisibility }) {
  const { selectedMetricDisplay, setSelectedMetricDisplay, selectedCategory, setSelectedCategory } = useAssetViewTemplateChart(ASSET_VIEW_PERFORMANCE_CHART)

  const analytics = useAnalytics()
  const { handleMetricDisplayChange, handleCategoryChange } = useAssetViewHeaderHandlers({
    track: analytics.track,
    setSelectedMetricDisplay,
    setSelectedCategory,
  })

  const metricOptions = useMemo(
    () => ({ prefix: "performance", selectedCategory, selectedMetricDisplay }),
    [selectedCategory, selectedMetricDisplay],
  )

  useSourceTemplateMetricIds({ flattenedMetrics, onMetricsChange, metricOptions, includeSummaryRows: true, compositionVisibility })

  const displayOptions = useMemo(() => METRIC_OPTIONS.performance.map(({ id, label, isDefault, secondaryText, tooltip }) => ({ id, primaryText: label, isDefault, secondaryText, tooltip })), [])

  const categoryOptions = useMemo(
    () => getFactorCategoryDropdownOptions(modelMetadata),
    [modelMetadata],
  )

  return <>
    <AssetViewPanelPeriodControl />
    <ListItemDropDown
      label="Metric Display"
      value={selectedMetricDisplay}
      setValue={handleMetricDisplayChange}
      options={displayOptions}
      alignMenu="left"
      disablePortal
    />
    <ListItemDropDown
      label="Factor view"
      value={selectedCategory}
      setValue={handleCategoryChange}
      options={categoryOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

PerformanceHeader.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
  flattenedMetrics: PropTypes.object,
  onMetricsChange: PropTypes.func,
  compositionVisibility: COMPOSITION_VISIBILITY_SHAPE,
}
